import React from "react"
import { TFormModalMode, TOnClick } from "../../../../Interfaces/GlobalInterface"
import ModalWithSepLine from "./ModalWithSepLine"
import { INewRequestFormField } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import UserSideNewRequestForm, {
	TOnSubmitNewRequestForm,
} from "components/ProjectSpecificComponents/Elements/AdminForm/molecules/Forms/UserSideNewRequestForm"
import { useTranslation } from "react-i18next"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"

interface Props {
	config: INewRequestFormField[]
	mode: TFormModalMode
	onClose?: TOnClick<HTMLButtonElement | HTMLElement>
	onSubmitForm?: TOnSubmitNewRequestForm
}

const NewRequestFormModal = ({ config, mode, onClose = () => {}, onSubmitForm }: Props) => {
	const { t } = useTranslation()

	return (
		<ModalWithSepLine title={t("user-request.make-new")} onClose={onClose}>
			<Whitespace x="1" />
			<UserSideNewRequestForm
				submitDisabled={mode == "preview"}
				config={config}
				onSubmitForm={onSubmitForm}
			/>
		</ModalWithSepLine>
	)
}

export default NewRequestFormModal
